import { ENV_CONFIG_ENV_TYPES, EnvironmentConfig } from '../app/environment.config';

export const environment: EnvironmentConfig = {
  production: true,
  idsApiUrl: 'https://identity.mindplay.com/',
  lsApiUrl: 'https://reader.lightsailed.com/',
  mpApiUrl: 'https://api.mindplay.com/',
  fluencyApiUrl: 'https://api-fluency.mindplay.com/',
  screenerApiUrl: 'https://api-screener.mindplay.com/',
  phonicsApiUrl: 'https://api-phonics.mindplay.com/',
  grammarApiUrl: 'https://api-grammar.mindplay.com/',
  academyApiUrl: 'https://academy.mindplay.com/',
  mpCoachUrlStudent: 'https://read.mindplay.com/mvrc/default.aspx',
  mpCoachUrlNonStudent: '',
  mpAccountUrl: 'https://account.mindplay.com/login',
  mpManagerUrl: 'https://manager.mindplay.com/account/login',
  lsV10Url: 'https://lightsailed.com/school/literacy',
  statsPageUrl: 'https://stats.mindplay.com/',
  cleverClientId: '665a46d36204a8d83c43',
  classLinkClientId: 'c1536154019710ee499dfbda6d1a84c98ec4fe27e4f0f2',
  gg4lClientId: 'PTRAPOWSUM',
  googleClientId: '872446888779-bhk2qk4ltdaljpks3vccv76tc5jijg85.apps.googleusercontent.com',
  googleMapsApiKey: 'AIzaSyAdg-bL3yneRMDCovXImPcng0V8-8NxUHI',
  microsoftSSOClientId: 'b32c61df-1250-41c4-a86e-8315b8381933',
  version: '20260929.1',
  applicationInsightsConnectionString:
    'InstrumentationKey=b1912ea2-80d9-451d-b8b9-1d8cc125c2ac;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=1b037ca4-a4d8-49e9-a0bf-ccec1e72107b',
  sandboxCustomerId: 15698,
  environment: ENV_CONFIG_ENV_TYPES.PROD,
};
